<template>
  <div class="border-b border-darkmode-50 text-xs text-right whitespace-nowrap overflow-x-auto">
    <AtomsTextLink v-if="!shopZone.disabledFeatures.includes('STORES_LINK_IN_HEADER')" class="header__link" :to="cache.getModuleUrl('modules/branches')">{{ $t('Prodejny') }}</AtomsTextLink><span v-if="!shopZone.disabledFeatures.includes('STORES_LINK_IN_HEADER')"> |</span>
    <AtomsTextLink v-if="!shopZone.disabledFeatures.includes('SERVICES_LINK_IN_HEADER')" class="header__link" :to="cache.getPageUrl(33210)">{{ $t('Služby') }}</AtomsTextLink><span v-if="!shopZone.disabledFeatures.includes('SERVICES_LINK_IN_HEADER')"> |</span>
    <AtomsTextLink class="header__link" :to="cache.getPageUrl(28805)">{{ $t('Stav objednávky') }}</AtomsTextLink> |
    <AtomsTextLink class="header__link" :to="cache.getPageUrl(3449)">{{ $t('Slevy a výhody') }}</AtomsTextLink> |
    <AtomsTextLink class="header__link" :to="cache.getPageUrl(26558)">{{ $t('Informační centrum') }}</AtomsTextLink> |
    <AtomsTextLink class="header__link" :to="cache.getModuleUrl('modules/inspiration')">{{ $t('Inspirace') }}</AtomsTextLink> |
    <AtomsTextLink class="header__link" :to="cache.getPageUrl(18438)">{{ $t('Magazín') }}</AtomsTextLink> |
    <AtomsTextLink class="header__link" :to="cache.getPageUrl(3453)">{{ $t('Kontakty') }}</AtomsTextLink>
  </div>
</template>
<script setup>

const cache = useCache();
const shopZone = useShopZone().value;

</script>